var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"text-center caption",attrs:{"cols":"12"}},[_vm._v("\n        Updated "+_vm._s(_vm.timestamp)+"\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }